export const flute = [,0,740,0,,0.15,2,0.2,-0.1,-0.15,9,0.02,,0.1,0.12,0,0.06];